import { reactive } from 'vue';

export const criarTpProducao = () => {
  return reactive({
    id: 0,
    idep: 0,
    cdtpproducao: 0,
    nmtpproducao: '',
    detalhamento: '',
    ativo: 'S',
    tpproduto_mapa: '',
    idlogin: 0
  });
};